import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlayCard", "editForm"];
  static values = { configId: String };

  toggleEdit(event) {
    const overlayId =
      event.currentTarget.dataset.overlayId ||
      event.params?.overlayId;
    if (!overlayId) return;

    const form = this.editFormTargets.find(
      (el) => el.dataset.overlayId === overlayId
    );
    if (!form) return;

    form.classList.toggle("hidden");
  }
}
